import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-font-icon',
  templateUrl: './global-font-icon.component.html',
  styleUrls: ['./global-font-icon.component.css']
})
export class GlobalFontIconComponent implements OnInit {
  @Input() style: 'duotone' | 'solid' | 'outline' = 'duotone';
  @Input() ICON: string;
  @Input() customClasses: string = '';
  @Input() customStyles: { [key: string]: string } = {};
  constructor() { }

  ngOnInit() {
  }

}
